import DeliverySDK from '@olxeu-a2b/core/src/api/DeliverySDK';
import { parseTransaction } from '../../extras';

export function getTransactionForOrder(sdk: DeliverySDK, orderId: string) {
  return sdk.getTransaction({ orderId }).then(({ data }) => parseTransaction(data));
}

export function getAllTransactions(sdk: DeliverySDK, type: string, page: number, pageSize: number) {
  return sdk
    .getTransactions({
      transactionType: type,
      'page.number': page.toString(),
      'page.size': `${pageSize}`,
    })
    .then(({ data }) => data.map(parseTransaction));
}
